export default __webpack_public_path__ + "static/01-fd85cf15b08792204b8346fbb5a2dac4.svg";